export default "__VITE_ASSET__bbef79a8__"